import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { StepperConfig } from 'qbe-components';
import { Observable, Subject, combineLatest, first, map } from 'rxjs';
import { STEPS_CONFIG } from '../../config/step.config';
import { environment } from '../../environments/environment';
import { ProcessService } from '../../services/process.service';
import { AppState } from '../../store';
import * as fromProcess from '../../store/process/process.reducer';
import { objectGetProp } from '../../utils';

@Component({
  selector: 'app-progress-stepper',
  templateUrl: './progress-stepper.component.html',
  styleUrls: ['./progress-stepper.component.scss'],
})
export class ProgressStepperComponent implements OnDestroy {
  appKind = environment.app;
  prevStepUrl$ = this.store.select(fromProcess.selectProcessPrevStepUrl);
  prevStepAvailable$ = this.store.select(fromProcess.selectProcessPrevAvailable);
  hideLeftArrowIcon$: Observable<boolean> = this.store.select(fromProcess.selectProcessPrevAvailable);
  progressStepperConfig$: Observable<StepperConfig | null> = combineLatest([
    this.store.select(fromProcess.selectProcessStepperConfig),
    this.translateService.getTranslation(this.translateService.currentLang),
  ]).pipe(
    map(([stepperConfig, translations]) => {
      if (!stepperConfig) {
        return null;
      }

      if (!translations) {
        return stepperConfig;
      }

      const stepsLabels = stepperConfig.stepsLabels?.map((label: string) => (objectGetProp(translations, label) as string) || label);

      return { ...stepperConfig, stepsLabels };
    }),
  );

  destroy$: Subject<void> = new Subject<void>();

  constructor(
    public processService: ProcessService,
    private store: Store<AppState>,
    private router: Router,
    private translateService: TranslateService,
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goToPreviousStep() {
    this.prevStepUrl$.pipe(first()).subscribe((stepUrl) => {
      void this.router.navigate(stepUrl);
    });
  }

  goToStep(stepIndex: number) {
    this.prevStepAvailable$.pipe(first()).subscribe((prevStepAvailable) => {
      if (!prevStepAvailable) {
        return;
      }

      const url = STEPS_CONFIG()[stepIndex].route;

      if (!url) {
        return;
      }

      void this.router.navigateByUrl(url);
    });
  }
}
